<div class="d-flex flex-column h-100">
  <span class="notes-label">These notes <span class="fw-bold">do not save to Byte</span></span>
  <textarea pTextarea class="form-control flex-grow-1 w-100 p-3" [formControl]="notesControl" [maxlength]="maxNoteLength"></textarea>
  <p class="d-flex justify-content-end fst-italic mt-2 mb-0">
    {{ notesControl?.value?.length || 0 | number }} / {{ maxNoteLength | number }} character limit
  </p>
</div>
